module.exports = __webpack_public_path__ + "static/media/smartphone.2093b58b.png";